import { BaseModel } from "../../_base/crud";
import { UserAffiliateStatus } from "../../../modules/management/shared/models/enums/userAffiliateStatus";
export class User {
  firstName: string;
  lastName: string;
  isMale: boolean;
  username: string;
  role: string;
  access_token: string;
  refresh_token: string;
  userStatus: number;
  isBeta: boolean = false;
  educationLevel: string;
  occupationField: string;
  usageField: string;
  walletBalance: number;
  isAddNewUserAllowed: boolean = false;
  userAffiliateStatus: UserAffiliateStatus;
  clear(): void {
    this.username = "";
    this.firstName = "";
    this.lastName = "";
    this.username = "";
    this.role = "";
    this.userStatus = 0;
    this.access_token = "access-token-" + Math.random();
    this.refresh_token = "access-token-" + Math.random();
    this.isMale = false;
    this.isBeta = false;
  }

  isAffiliateUser(): boolean {

    if (!this.userAffiliateStatus || this.userAffiliateStatus == undefined) return false;
    return this.userAffiliateStatus == UserAffiliateStatus.Approved;
  }
}
